import { styled } from '@mui/material';
import {
  PickersTextField,
  type PickersTextFieldProps,
} from '@mui/x-date-pickers/PickersTextField';

type CustomPickerTextFieldProps = Omit<PickersTextFieldProps, 'variant'>;

export const CustomPickerTextField = styled(
  (props: CustomPickerTextFieldProps) => (
    <PickersTextField variant="standard" {...props} />
  ),
)(({}) => ({
  '& .MuiPickersInputBase-root': {
    height: 35,
    position: 'relative',
    padding: '5.585px 8px 5.585px 8px',
    borderRadius: 4,
    border: '1px solid #cbcaca',
    fontSize: 13,
    backgroundColor: '#fff',
    marginTop: 0,

    '&:before, &:after': {
      display: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline.Mui-error:after': {
      borderBottom: 'none',
    },

    '&.Mui-focused': {
      outline: '2px solid #bdbdbd',
      outlineOffset: '2px',
      borderRadius: 4,
      backgroundColor: 'unset',
    },

    '&.Mui-disabled': {
      backgroundColor: '#EFEFEF',
      borderColor: '#D8D6DE',
      cursor: 'default',
    },

    '& .MuiInputBase-input': {
      color: '#4C4C4C',
    },

    '& .MuiInputBase-input.Mui-disabled': {
      WebkitTextFillColor: '#858585',
    },

    '&.Mui-readOnly': {
      borderColor: 'transparent',
      backgroundColor: '#F9F9FA',
    },

    '&.Mui-error': {
      borderColor: '#D82C0D',
    },

    '& ::placeholder': {
      color: '#828D98',
      opacity: 1,
    },
  },

  '& .MuiInputLabel-root': {
    position: 'static',
    height: 20,
    transform: 'none',
    fontSize: 13,
    fontWeight: 500,
    marginBottom: 4,
    color: '#4C4C4C',
    '& .MuiFormLabel-asterisk': {
      color: '#D82C0D',
      fontWeight: 500,
    },

    '&.Mui-error, &.Mui-disabled': {
      color: '#858585',
    },
  },

  '& .MuiFormHelperText-root': {
    height: 20,
    marginLeft: 0,
    fontSize: 13,
    color: '#63717E',
    '& .Mui-error': {
      color: '#D82C0D',
    },
  },
}));
